import CredentialsService from '../services/credentials.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const credentialsModule = {
  namespaced: true,

  actions: {
    async searchLogin ({ commit }, rechercheLogin) {
      return CredentialsService.searchLogin(rechercheLogin).then(
        response => {
          const login = response.data
          return Promise.resolve(login)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async searchPassword ({ commit }, recherchePassword) {
      return CredentialsService.searchPassword(recherchePassword).then(
        response => {
          const isPasswordSent = response.data
          return Promise.resolve(isPasswordSent)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    }
  }
}
